import { addToFavorites } from './addToFavorite';
import { TThunkAction } from '../../types/redux';
import { requestAuthentication } from '../authentication/requestAuthentication';

export const onAddToFavorite = (offerId: number): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { microfrontendsAPI } = context;
    const { user } = getState();

    if (microfrontendsAPI && !user.isAuthenticated) {
      microfrontendsAPI.header.openAuthModal({ autoRefresh: false, viewData: { headingType: 'addFavorite' } });
      dispatch(
        requestAuthentication({
          source: 'favorites',
          viewData: { headingType: 'addFavorite' },
          onSuccess: (): TThunkAction => dispatch => {
            dispatch(addToFavorites(offerId));
          },
        }),
      );
    } else {
      dispatch(addToFavorites(offerId));
    }
  };
};
